import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  inline: PropTypes.bool,
  defaultChecked: PropTypes.bool
};

const defaultProps = {
  placeholder: '',
  inline: false,
  className: ''
};

export default class CheckboxInput extends PureComponent {
  render() {
    const { id, label, inline, placeholder, value, className, ...rest } = this.props;
    const wrapClass = inline ? 'rec-form-inline-item' : 'rec-form-check-wrap';
    const classes = `${wrapClass} ${className}`;

    return (
      <div className={classes}>
        <label className="rec-label-checkbox" htmlFor={id}>
          <input
            type="checkbox"
            id={id}
            className="rec-input-hide"
            placeholder={placeholder || label}
            value={value}
            {...rest} />
          <span className="rec-input-checkbox" />
          {label}
        </label>
      </div>
    );
  }
}

CheckboxInput.propTypes = propTypes;
CheckboxInput.defaultProps = defaultProps;
